$shm_hitalama_vk_group_search $mol_view
	token_str \
	group_id \
	owner_id \
	search_result? null
	reset null
	dto null $shm_hitalama_vk_group_dto
	search_click null
	sub /
		<= Search_label $mol_labeler
			label <= search_label /$mol_view_content
				<= search_title \Введите ссылку на сообщество
			content /
				<= Group_id $mol_string
					value? <=> search_value? \smmblog
				<= Search $mol_button_major
					title \Поиск
					click? <=> search? null
					hint \https://vk.com/smmblog
		^ search_result_view /
			<= Group $mol_view
				sub /
					<= Photo $mol_image
						uri <= photo_uri \
					<= Name_block $mol_view
						sub /
							<= Name $mol_paragraph
								title <= name \
							<= Members_count $mol_view
								sub /
									<= Members_count_icon $mol_icon_account_group_outline
									<= members_count? \
					^ buttons /
	Search_error $mol_text
		text <= error_message \
